import { useEffect, useState } from "react";
import { Spin } from "antd";
import { Icon, Select, Tabs } from "Components";
import Header from "PhishingManager/components/Header";
import GridReportCard from "./components/GridReportCard";
import FlexReportCard from "./components/FlexReportCard";
import OverAllCard from "./components/OverallCard";
import ReportList from "./components/ReportList";
import { TABLE_TABS } from "./CampaignReport.constant";
import { capitalize } from "PhishingManager/utils";
import LearnMoreModal from "./components/LearnMoreModal";
import "./CampaignReport.scss";

type CampaginReportProps = {
    showOverallReport: boolean,
    campaignId: number | null,
    tenentId: number | null
}

const CampaignReport = ({ showOverallReport, campaignId, tenentId }: CampaginReportProps) => {
    const [campaignState, setCampaginState] = useState({ id: 2, venzaTenentId: 2 });
    const [activeTab, setActiveTab] = useState("individual");
    const [showLearnMore, setShowLearnMore] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const updatedState: any = {};
        if (campaignId) updatedState["id"] = 2;
        if (tenentId) updatedState["venzaTenentId"] = tenentId;
        setCampaginState(prev => ({ ...prev, ...updatedState }));
    }, [])

    return <div className="campaign-report-container">
        {showOverallReport && <Spin spinning={isLoading}>
            <div className="overall-section">
                <Header title="Overall Results" description="" parentClass='phishing-header'>
                    <div className="pm-dropdown-section">
                        <label htmlFor="campagin-select" className="pm-client-label">
                            Tenant
                        </label>
                        <Select
                            id="campagin-select"
                            placeholder="Select a Campagin"
                            dropdownClassName="campaign-setup-filter-option-select"
                            value={campaignState.id}
                            loading={isLoading}
                            onChange={(value) => setCampaginState(prev => ({ ...prev, id: value }))}
                            showSearch
                            disabled={isLoading}
                            suffixIcon={<Icon type="campaignDropdown" />}
                            options={[{ label: "Campaign One", value: 2 }]}
                            getPopupContainer={(trigger) => trigger.parentElement}
                        />
                    </div>
                </Header>
                <div className="cards-flex">
                    <OverAllCard label="OVERALL" title="Overall Pass Rate" desc="Combined rate of all phishing simulations" data={[{ label: "", count: 95.5, showTag: true }]} />
                    <OverAllCard label="RECENT ACTIVITY" title="Last Campaign" desc="Feedback Collection 3 | 1/5/2026" data={[{ label: "Pass Rate", count: 85.5, showTag: true }, { label: "Fail Rate", count: 13, showTag: false }]} />
                    <OverAllCard label="SUMMARY" title="Phishing Campaigns" desc="Total campaigns in the last 12 months" data={[{ label: "", count: 4, showTag: false }]} />
                </div>
            </div>
        </Spin>}
        <div className="campaign-section">
            <Spin spinning={isLoading} wrapperClassName="loading-container">
                <Header title="Campaign Report" description="" parentClass='phishing-header'>
                    <div className="pm-dropdown-section">
                        <Select
                            id="campagin-select"
                            placeholder="Select a Campagin"
                            dropdownClassName="campaign-setup-filter-option-select"
                            value={campaignState.id}
                            loading={isLoading}
                            onChange={(value) => setCampaginState(prev => ({ ...prev, id: value }))}
                            showSearch
                            disabled={isLoading}
                            suffixIcon={<Icon type="campaignDropdown" />}
                            options={[{ label: "Campaign One", value: 2 }]}
                            getPopupContainer={(trigger) => trigger.parentElement}
                        />
                    </div>

                    <Icon type="download" className="icon-btn download-btn" onClick={() => console.log("download")} />
                    <Icon type="campaignInfo" className="icon-btn info-btn" onClick={() => setShowLearnMore(true)} />
                </Header>

                <div className="report-card">
                    <span className="card-title">Overall Results</span>
                    <div className="cards-grid">
                        <GridReportCard label="Name" desc="Fake Login – Corporate Portal" iconType="feedback" />
                        <GridReportCard label="Date" desc="11/20/2025" iconType="calendarReport" />
                        <GridReportCard label="Properties" desc="1" iconType="properties" />
                        <GridReportCard label="Target Users" desc="1508" iconType="usersReport" />
                    </div>
                </div>

                <div className="report-card">
                    <span className="card-title">Core Metrics</span>
                    <div className="cards-flex">
                        <FlexReportCard isPassCard={true} iconType="shield" label="Pass Rate" score={95.5} desc="Users who passed the test" toolTipText="Percentage of users who successfully passed the phishing test based on their interaction with the email." />
                        <FlexReportCard isPassCard={false} iconType="emailSent" label="Email Sent" score={450} desc="Emails Successfully Sent" toolTipText="Total number of emails sent. Some emails may not have been sent due to delivery restrictions." />
                        <FlexReportCard isPassCard={false} iconType="emailOpen" label="Opened Email" score={320} desc="71% open rate" toolTipText="Number of users who opened the phishing email at least once." />
                        <FlexReportCard isPassCard={false} iconType="userClick" label="Clicked Link" score={18} desc="4% click rate" toolTipText="Number of users who clicked on a link in the email." />
                        <FlexReportCard isPassCard={false} iconType="submittedData" label="Submitted Data" score={5} desc="1% submission rate" toolTipText="Number of users who submitted information after interacting with the email." />
                    </div>
                </div>
            </Spin>
            <div className="tab-section">
                <Tabs activeKey={activeTab} onChange={setActiveTab}>
                    {TABLE_TABS.map(item => <Tabs.TabPane tab={capitalize(item)} key={item}>
                        <ReportList tab={activeTab} />
                    </Tabs.TabPane>)}
                </Tabs>
            </div>
        </div>
        {showLearnMore && <LearnMoreModal open={showLearnMore} onClose={() => setShowLearnMore(false)} onConfirm={() => setShowLearnMore(false)} />}
    </div>
}

export default CampaignReport;